export default __webpack_public_path__ + "./image/2a6ea60a57862308258e79df7023cfa4.png";